export class Progress {

	//saveChange(p1, p2, p3) {
	//	this.doSomething();
	//}

	//doSomething() {
	//	console.log("Something");
	//}

	change(event) {
		let progress = $('#progressBar').data('ejProgressBar');
		progress.setModel({ text: event.percentage + ' %' });
		//console.log('Progressbar value has been changed to ' + args.percentage + '%.');
		
	}
}